import React from 'react';
import './CallSummary.css';

function CallSummary({ summary, onClose }) {
  if (!summary) return null;

  return (
    <div className="call-summary-overlay">
      <div className="call-summary-modal">
        <div className="summary-header">
          <h2>📋 Conversation Summary</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="summary-content">
          {summary.user_name && (
            <div className="summary-section">
              <strong>User:</strong> {summary.user_name}
            </div>
          )}

          {summary.user_phone && (
            <div className="summary-section">
              <strong>Phone:</strong> {summary.user_phone}
            </div>
          )}

          <div className="summary-section">
            <strong>Duration:</strong> {summary.session_duration_seconds || 0} seconds
          </div>

          <div className="summary-section">
            <strong>Conversation Turns:</strong> {summary.conversation_turns || 0}
          </div>

          {summary.intents_identified && summary.intents_identified.length > 0 && (
            <div className="summary-section">
              <strong>Actions Performed:</strong>
              <ul>
                {summary.intents_identified.map((intent, idx) => (
                  <li key={idx}>{intent.replace('_', ' ')}</li>
                ))}
              </ul>
            </div>
          )}

          {summary.pending_appointment && (
            <div className="summary-section highlight">
              <strong>📅 Appointment Booked:</strong>
              <div className="appointment-details">
                <div>Date: {summary.pending_appointment.date || summary.pending_appointment.appointment_date}</div>
                <div>Time: {summary.pending_appointment.time || summary.pending_appointment.appointment_time}</div>
                {summary.pending_appointment.notes && (
                  <div>Notes: {summary.pending_appointment.notes}</div>
                )}
              </div>
            </div>
          )}

          <div className="summary-section">
            <strong>Session ID:</strong>
            <code>{summary.timestamp}</code>
          </div>
        </div>

        <div className="summary-footer">
          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default CallSummary;

